import React from "react";
import Layout from "../../components/layout";
import { Link } from "react-router-dom";

import styles from "./NotFoundPage.module.scss";
import { route } from "../../static/route";
import { t } from "../../locales";

const NotFoundPage = () => {
  const companyName = process.env.REACT_APP_COMPANY_NAME;

  return (
    <Layout>
      <div className={styles.NotFoundPage}>
        <div className="logoSection">
          <h1 className="text-5xl font-bold text-white lg:text-3xl">
            {companyName}
          </h1>

          <hr className="w-[180px] border-white border-[4px] rounded-[4px] mx-auto mt-4 lg:mx-0 lg:w-24 lg:border-[2px] lg:mt-2" />
        </div>
        <div className="mt-[70px] px-4 md:px-10 py-5 text-center">
          <p className="mt-4 text-primary-2 font-bold text-2xl">
            {t.notFound.title}
          </p>
          <p className="mt-4 text-primary-2 font-semibold text-lg">
            {t.notFound.description}
          </p>
          <p className="mt-4 text-primary-2 font-semibold text-lg">
            {t.notFound.goToMain} <br />
            <Link to={route.home}>
              <a className="text-xl font-bold underline">{t.notFound.clickHere}</a>
            </Link>
          </p>
        </div>
      </div>
    </Layout>
  );
};
export default NotFoundPage;
